import createIcon from '../../createIcon';

/**
 * @component @name AddAPhoto
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMy41IDQuNVYxLjVINS41VjQuNUg4LjVWNi41SDUuNVY5LjVIMy41VjYuNUgwLjVWNC41SDMuNVpNNi41IDEwLjVWNy41SDkuNVY0LjVIMTYuNUwxOC4zMyA2LjVIMjEuNUMyMi42IDYuNSAyMy41IDcuNCAyMy41IDguNVYyMC41QzIzLjUgMjEuNiAyMi42IDIyLjUgMjEuNSAyMi41SDUuNUM0LjQgMjIuNSAzLjUgMjEuNiAzLjUgMjAuNVYxMC41SDYuNVpNMTMuNSAxOS41QzE2LjI2IDE5LjUgMTguNSAxNy4yNiAxOC41IDE0LjVDMTguNSAxMS43NCAxNi4yNiA5LjUgMTMuNSA5LjVDMTAuNzQgOS41IDguNSAxMS43NCA4LjUgMTQuNUM4LjUgMTcuMjYgMTAuNzQgMTkuNSAxMy41IDE5LjVaTTEwLjMgMTQuNUMxMC4zIDE2LjI3IDExLjczIDE3LjcgMTMuNSAxNy43QzE1LjI3IDE3LjcgMTYuNyAxNi4yNyAxNi43IDE0LjVDMTYuNyAxMi43MyAxNS4yNyAxMS4zIDEzLjUgMTEuM0MxMS43MyAxMS4zIDEwLjMgMTIuNzMgMTAuMyAxNC41WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const AddAPhoto = createIcon('AddAPhoto', [
  [
    'path',
    {
      d: 'M3.5 4.5V1.5H5.5V4.5H8.5V6.5H5.5V9.5H3.5V6.5H0.5V4.5H3.5ZM6.5 10.5V7.5H9.5V4.5H16.5L18.33 6.5H21.5C22.6 6.5 23.5 7.4 23.5 8.5V20.5C23.5 21.6 22.6 22.5 21.5 22.5H5.5C4.4 22.5 3.5 21.6 3.5 20.5V10.5H6.5ZM13.5 19.5C16.26 19.5 18.5 17.26 18.5 14.5C18.5 11.74 16.26 9.5 13.5 9.5C10.74 9.5 8.5 11.74 8.5 14.5C8.5 17.26 10.74 19.5 13.5 19.5ZM10.3 14.5C10.3 16.27 11.73 17.7 13.5 17.7C15.27 17.7 16.7 16.27 16.7 14.5C16.7 12.73 15.27 11.3 13.5 11.3C11.73 11.3 10.3 12.73 10.3 14.5Z',
      key: '1s9c2x',
    },
  ],
]);

export default AddAPhoto;
